(() => {
  'use strict';
  if (window.__arvessCheckoutTracking || window.Shopify?.designMode) return;
  const endpoint = document.currentScript?.dataset.collector;
  if (!endpoint) return;
  window.__arvessCheckoutTracking = true;
  try {
    if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
    }
  } catch { /* Tracking is optional; checkout is never blocked. */ }
  let lastClick = 0;
  document.addEventListener('click', event => {
    try {
      if (!event.isTrusted || !(event.target instanceof Element)) return;
      const button = event.target.closest('[data-arvess-checkout-position]');
      const page = button?.closest('.cart-page');
      if (!button || !page || button.disabled) return;
      const position = button.dataset.arvessCheckoutPosition;
      if (position !== 'top' && position !== 'bottom') return;
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true) return;
      const variants = new Set(); let units = 0;
      for (const row of page.querySelectorAll('[data-arvess-cart-variant]')) {
        const quantity = Number(row.querySelector('input[name="updates[]"]')?.value ?? row.dataset.arvessCartQuantity);
        if (!Number.isInteger(quantity) || quantity < 0) return;
        if (quantity > 0) { variants.add(row.dataset.arvessCartVariant); units += quantity; }
      }
      if (!variants.size || variants.size > 1000 || units > 10000) return;
      const now = Date.now(); if (now - lastClick < 1500) return;
      lastClick = now;
      const body = JSON.stringify({ id: crypto.randomUUID(), position, positions: variants.size, units });
      if (navigator.sendBeacon?.(endpoint, new Blob([body], { type: 'text/plain' }))) return;
      void fetch(endpoint, { method: 'POST', body, keepalive: true, credentials: 'omit', referrerPolicy: 'no-referrer', headers: { 'Content-Type': 'text/plain' } }).catch(() => {});
    } catch { /* Fail silently, with no change to native checkout submission. */ }
  }, true);
})();
